export default __webpack_public_path__ + "static/media/puppetsofset.7605ba44.png";